import React from 'react';
import { PageProps, FileItem } from '../components/component-switcher';
import FileComponent from '../components/file-component';
import PageGrid from '../components/page-grid';
import SectionTitle from '../components/section-title';
import { createCategories, generateSectionId } from '../helpers/layout-helpers';
import DownloadBar from '../components/download-bar';
export interface FilePage extends PageProps {
  itemChildren: FileItem[];
}

export interface FileArchiveState {
  selectedItems: FileItem[];
}

export const AllowedFileConversions = ['LogoArchive'];

class FileArchive extends React.Component<FilePage, FileArchiveState> {
  // constructor(props: any) {
  //     super(props);
  // }

  render() {
    let className = `file-archive ${this.props.type.toLowerCase()}`;
    if (this.props.sideMenuTitle) {
      className += ' can-scroll-to';
    }
    let Component = this.props.component || FileComponent;
    let categories = createCategories(this.props.itemChildren, Component);
    let enableConversions = AllowedFileConversions.includes(this.props.type);
    let enableDownloads =
      this.props.itemChildren.filter((item: any) => {
        return !item.disableDownload;
      })?.length > 0;
    return (
      <section className={className} id={generateSectionId(this.props)}>
        <SectionTitle title={this.props.mainTitle} />
        {this.props.pageDescription && (
          <div
            className='text-content'
            dangerouslySetInnerHTML={{
              __html: this.props.pageDescription,
            }}
          />
        )}
        {enableDownloads && (
          <DownloadBar
            isMulti={this.props.itemChildren?.length > 1}
            enableConversions={enableConversions}
            {...this.props}
            selectedItems={this.props.selectedItems || []}
          />
        )}
        <PageGrid
          columns={this.props.columns || 5}
          childrenLength={categories?.map(
            (item: any) => item.itemChildren.length
          )}
          childrenArray={categories.reduce((results: any[], cat) => {
            // if (cat.heading) {
            //     results.push(
            //         <h3
            //             key={cat.key + "-heading"}
            //             className="category-heading"
            //         >
            //             {cat.heading}
            //         </h3>
            //     );
            // }
            cat.itemChildren.forEach((props: any) => {
              props.hideTitle = this.props.hideTitle;
              props.childrenLength = cat.itemChildren.length;

              results.push(
                <div
                  key={props.key}
                  className={`${
                    cat.itemChildren.length === 1
                      ? 'section-grid-item-mobile-full-width'
                      : ''
                  }`}>
                  <Component key={cat.key} {...props} />
                </div>
              );
            });

            return results;
          }, [])}
        />
      </section>
    );
  }
}

export default FileArchive;
